module.exports = __webpack_public_path__ + "img/top-10-cart.b3bb4900.jpg";